import { render, staticRenderFns } from "./CreateQuiz.vue?vue&type=template&id=8e8e7026"
import script from "./CreateQuiz.vue?vue&type=script&lang=js"
export * from "./CreateQuiz.vue?vue&type=script&lang=js"
import style0 from "./CreateQuiz.vue?vue&type=style&index=0&id=8e8e7026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports